/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 05:27:06
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIToggle,
    EUITagRuleUnion,
} from "../core";
import Vue from "vue";

// uiToggle does two things:
//  1) set uiHidden by state
//  2) set uiRequired by state
// show up if true, show off otherwise.
// example: @uiToggle - (o) => ({ state: !o.value })

@UITag.set()
export class uiToggle extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement, EUITagTarget.FormSubmit];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Object];
    allowNullRule: boolean = false;

    parse(input: IUITagInput): IUITagResult | null {
        let rule: IUIToggle | null = this.parseRule(input) as any;
        if (rule == null) return null;
        let moreTags: IUITagMoreTagsUnit[] = [];

        /// 1) set uiHidden by state
        moreTags.push({ tag: "uiHidden", rule: !rule.state });
        /// 2) set uiRequired by state.
        /// don't change the require state if defaulty optional.
        const optional = input.meta.attr.type.optional;
        if (!optional) {
            moreTags.push({ tag: "uiRequired", rule: rule.state });
        }
        /// 3) set uiSubmitIgnore by state.
        moreTags.push({ tag: "uiSubmitIgnore", rule: !rule.state });

        return {
            specials: {
                moreTags,
            },
        };
    }
}
